export const NEW_SCHEDULE = 'NEW_SCHEDULE';
export const GET_SCHEDULES = 'GET_SCHEDULES';
export const UPDATE_SCHEDULAR = 'UPDATE_SCHEDULAR';
export const DELETE_SCHEDULAR = 'DELETE_SCHEDULAR';
